import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-phone-number-screen';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { phoneConfirmation } from '../../api/profile.ts';

function RegisterPhoneNumber() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      phone_number: '',
    },
    validate: {
      phone_number: (value) => (/^\+?[1-9]\d{1,14}$/.test(value) ? null : 'Invalid phone number'),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    phoneConfirmation({ phoneNumber: values.phone_number })
      .then((response) => {
        localStorage.setItem('ffm_register_phone_number_confirmation', response.data.id);
        navigate(LINKS.REGISTER_VERIFY_CODE);
      })
      .catch((error) => {
        form.setErrors({
          phone_number: error.response.data.fields?.find(
            (field: { fieldName: string; message: string }) => field.fieldName === 'phoneNumber',
          )?.message,
        });
      });
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} />;
}

export default RegisterPhoneNumber;
